
import Bg from '../../../assets/img/photos/blog.JPG'


export default function PostBanner() {
    return (
        <section className="wrapper image-wrapper bg-image bg-overlay text-white" data-image-src="https://static.businessworld.in/article/article_extra_large_image/1478073024_Frbdt4_agritech.jpg">
            <div className="container pt-17 pb-13 pt-md-19 pb-md-17 text-center">
                <div className="row">
                    <div className="col-md-10 col-xl-8 mx-auto">
                        <div className="post-header">
                            <div className="post-category text-line text-white">
                                <a href="/" className="text-reset" rel="category">InfyULabs</a>
                            </div>
                            <h1 className="display-1 mb-4 text-white">Using agritech to solve the Indian export crisis</h1>
                            {/* <ul className="post-meta text-white">
                                <li className="post-date"><i className="uil uil-calendar-alt"></i><span>5 Jul 2021</span></li>
                                <li className="post-author"><i className="uil uil-user"></i><a href="/#" className="text-reset"><span>By Ragahva Segu</span></a></li>
                            </ul> */}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}